// Full-document render of the stearns ReviewsPage: PageSkeleton (the React
// document shell) wrapping the love-root hub header + breadcrumb (rendered only
// when the page sits under a TempurLoveRootPage), the existing reviews-page body
// assembly, and the shared reviews SPA. The love_root branch has two arms:
// without a love-root the standalone
// write-review button island precedes a `.review-spa` section; with one the SPA
// sits in a `.customer-review > .review-spa.review-spa__tempur-love` container
// and its write_review_url points at the tempur-love form (resolved server-side).
//
// The iovation scripts are page-scoped here (legacy included
// `tsicommon/reviews/iovation.html` only on this page; stearns' PageSkeleton does
// not render iovation globally). They are injected imperatively from a
// post-hydration effect (IovationScripts) rather than as declarative React
// <script>s to keep the IGLOO -> snare -> loader execution order under React 19.
import React from "react";
import { IovationScripts } from "tsi-common-react/src/components/IovationScripts/index";

import { Context, templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { ReviewsPageBody } from "../components/ReviewsPageBody";
import { TempurLoveHeader } from "../components/TempurLoveHeader";
import { Template as ReviewsSPA } from "./ReviewsPageTemplate";
import { Template as WriteReviewButton } from "./WriteReviewButtonTemplate";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader/RichNavigation chain via PageSkeleton, which is typed with
// mutable reactivated props. The islands accept Immutable props, to which these
// are assignable.
export const Template = (
    props: templates.ReviewsPageDocumentTemplate,
): React.JSX.Element => {
    const { page, love_root } = props;
    const chrome = React.useContext(Context).chrome;
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            {love_root && (
                <>
                    <TempurLoveHeader love_root={love_root} />
                    <div className="tempurlove-breadcrumbs tempurlove-breadcrumbs--reviews l-full-width">
                        <article className="sub-nav">
                            <nav className="breadcrumb" aria-label="Breadcrumb">
                                <ul className="breadcrumb__list">
                                    <li className="breadcrumb__list-item">
                                        <a href={love_root.url}>
                                            {love_root.title}
                                        </a>
                                    </li>
                                    <li
                                        className="breadcrumb__list-item"
                                        aria-current="page"
                                    >
                                        <a> {page.title}</a>
                                    </li>
                                </ul>
                            </nav>
                        </article>
                    </div>
                </>
            )}
            <ReviewsPageBody page={page} />
            {!love_root ? (
                <>
                    <WriteReviewButton
                        brand="Stearns & Foster"
                        product_type_whitelist=""
                    />
                    <section className="review-spa">
                        <ReviewsSPA {...props} />
                    </section>
                </>
            ) : (
                <div className="customer-review">
                    <section className="review-spa review-spa__tempur-love">
                        <ReviewsSPA {...props} />
                    </section>
                </div>
            )}
            <IovationScripts
                iovationUrl={props.iovation_url}
                staticBase={chrome.static_base}
            />
        </PageSkeleton>
    );
};
